var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.414,
    height: 10.828,
    viewBox: "0 0 70.414 10.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(-135 -226.586)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 68,
    transform: "translate(136 232)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    y2: 8,
    transform: "translate(136 228)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 4,
    y2: 4,
    transform: "translate(200 228)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y1: 4,
    x2: 4,
    transform: "translate(200 232)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine8);
export default __webpack_public_path__ + "static/media/line8.a03d110090ebc253225b8065c9edb6b2.svg";
export { ForwardRef as ReactComponent };